module.exports = __webpack_public_path__ + "assets/img/classroom_1.60501ae1.jpg";